// Side effects of logging a run, applied no matter WHERE the run was logged
// (Running tab, Today screen run card, etc.) so the mile tracker + adaptive
// easy pace always update. Previously these only fired from the Running tab.

import { loadGoals, upsertGoal, loadSettings, saveSettings } from './grit-data.js';
import { activeUser } from './auth.js';
import { adaptEasyMph, DEFAULT_EASY_MPH } from './run-plan.js';

function milePaceSec(run) {
  if (Number.isFinite(run.paceSec)) return Math.round(run.paceSec);
  if (run.avg_pace && /^\d+:\d{2}$/.test(run.avg_pace)) { const [m, s] = run.avg_pace.split(':').map(Number); return m * 60 + s; }
  const min = Number(run.actual_minutes), d = Number(run.actual_distance_mi);
  return (min && d) ? Math.round((min * 60) / d) : null;
}

export async function applyRunSideEffects(run) {
  const out = {};
  if (!run) return out;
  // A mile test updates the "current mile" tracker.
  if (run.type === 'timetrial') {
    const sec = milePaceSec(run);
    if (sec) {
      const goals = await loadGoals(activeUser());
      const mile = goals.find((g) => g.kind === 'mile_time');
      await upsertGoal({ kind: 'mile_time', current: String(sec), target: mile?.target || '450' });
      out.mileSec = sec;
    }
  }
  // Easy/long runs nudge the adaptive easy pace (used by the running plan).
  const s = await loadSettings(activeUser());
  const cur = Number(s.run_easy_mph) || DEFAULT_EASY_MPH;
  const next = adaptEasyMph(cur, { type: run.type, rpe: run.rpe });
  if (next !== cur) { await saveSettings({ run_easy_mph: next }); out.easyMph = next; out.prevEasyMph = cur; }
  return out;
}
